const LAST_ACTIVITY_KEY = 'sessionLastActivityAt';
const SESSION_LOCKED_KEY = 'sessionLocked';

export const getLastActivityAt = () => {
	const stored = localStorage.getItem(LAST_ACTIVITY_KEY);
	if (!stored) return Date.now();
	const parsed = Number(stored);
	return Number.isFinite(parsed) ? parsed : Date.now();
};

export const touchActivity = () => {
	localStorage.setItem(LAST_ACTIVITY_KEY, String(Date.now()));
	localStorage.removeItem(SESSION_LOCKED_KEY);
};

export const setSessionLocked = (locked) => {
	if (locked) {
		localStorage.setItem(SESSION_LOCKED_KEY, 'true');
	} else {
		localStorage.removeItem(SESSION_LOCKED_KEY);
	}
};

export const isSessionLocked = () =>
	localStorage.getItem(SESSION_LOCKED_KEY) === 'true';

export const clearSessionIdleState = () => {
	localStorage.removeItem(LAST_ACTIVITY_KEY);
	localStorage.removeItem(SESSION_LOCKED_KEY);
};

export const SESSION_IDLE_STORAGE_KEYS = {
	LAST_ACTIVITY_KEY,
	SESSION_LOCKED_KEY,
};
